module.exports = {
  ENV: 'prod',
  APP_NAME: 'metropolis2',
  END_POINT: 'https://ssm.services.apihf.com',
  API_KEY: 'aHSsjUn8MwNSnY3CxwLc96qVdBs8AnL3fyxeHS72',
  BRAND_KEY: '65889770-7a69-4377-9dc7-5e50272d0c8d',
  LANG: 'fr-FR'
}